<div class="layout-main">

  <div class="chat-container">
    <div class="chat-list-column">
      <app-chat-list-panel
        [recentConversation]="someRecentChats"
        [selectedConversation]="selectedConversation"
        (conversationUnavailable)="onConversationUnavailable($event)">
      </app-chat-list-panel>
    </div>

    <div class="chat-panel-column">
      <app-chat-panel
        [messagesIncoming]="messageChat"
        [selectedConversation]="selectedConversation"
      ></app-chat-panel>
    </div>

  </div>
</div>
